import { apiRequest } from '../api/client';
import { AutoFillParams, AutoFillResponse, ColumnsResponse, DataSourceWithExtras, GenericDatabasePayload, GetSupportedDataSourcesParams, TestConnectionResponse, Transformation, UpdateRecordParams, UpdateRecordResponse } from './common.types';

export const commonService = {
  async autoFill(params: AutoFillParams): Promise<AutoFillResponse> {
    const { baseName, tableName, type = 'nanoid' } = params;

    if (!baseName?.trim() || !tableName?.trim()) {
      throw new Error('baseName and tableName are required');
    }

    return apiRequest<AutoFillResponse>({
      method: 'GET',
      url: '/auto-fills',
      params: {
        baseName,
        tableName,
        type
      },
    }, 'Failed to fetch auto-fill');
  },

  dataSourcesFilter: async (
    params?: GetSupportedDataSourcesParams
  ): Promise<DataSourceWithExtras[]> => {
    const queryParams = {
      column_name: params?.column_name,
      value: params?.value ?? true,
      show_schema_definition: params?.show_schema_definition ?? false,
      show_prerequisite: params?.show_prerequisite ?? false,
    };

    return apiRequest<DataSourceWithExtras[]>({
      method: 'GET',
      url: '/data-sources/filter',
      params: queryParams,
    }, 'Failed to fetch data sources');
  },

  getTransformations: async (): Promise<Transformation[]> => {
    return apiRequest<Transformation[]>({
      method: 'GET',
      url: '/transformations',
    }, 'Failed to fetch transformations');
  },

  testConnection: async (
    params: GenericDatabasePayload
  ): Promise<TestConnectionResponse> => {
    return apiRequest<TestConnectionResponse>({
      method: 'POST',
      url: '/connections/test',
      data: params,
    }, 'Failed to test connection');
  },

  getColumns: async (params: GenericDatabasePayload): Promise<ColumnsResponse[]> => {
    return await apiRequest<ColumnsResponse[]>({
      method: 'POST',
      url: '/connections/columns',
      data: params,
    }, 'Failed to fetch columns');
  },

  updateRecord: async (tableName: string, params: UpdateRecordParams): Promise<UpdateRecordResponse> => {
    return await apiRequest<UpdateRecordResponse>({
      method: 'PUT',
      url: `/records/${tableName}`,
      data: params,
    }, `Failed to update ${tableName}`);
  }
};
